











import { Component, Mixins } from "vue-property-decorator";
import Tabs from "trade/components/orders/Tabs.vue";
import AutoOrderList from "trade/components/orders/AutoOrderList.vue";
import InstantOrderList from "trade/components/orders/InstantOrderList.vue";
import WyreOrderList from "trade/components/orders/WyreOrderList.vue";
import { TradeStrategy } from "@foxone/api/src/models/market";
import { Mutation } from "vuex-class";
import mixins from "@/mixins";

@Component({
  components: {
    Tabs,
    AutoOrderList,
    InstantOrderList,
    WyreOrderList
  }
})
class Orders extends Mixins(mixins.page) {
  @Mutation("trade/orders/SET_ORDER_TAB_INDEX") setOrderTabIndex;

  loading = true;

  get title() {
    return this.$t("common.order.mine") as string;
  }

  get typeIndex() {
    return this.$store.state.trade.orders.orderTabIndex;
  }

  set typeIndex(value) {
    this.setOrderTabIndex(value);
  }

  get types() {
    const types: any = [
      {
        text: this.$t("trade.enum.trade-strategy.market"),
        value: "instant-trade",
        component: "instant-order-list",
        props: { strategy: TradeStrategy.MARKET }
      },
      {
        text: this.$t("trade.enum.trade-strategy.flex"),
        value: "auto-trade",
        component: "auto-order-list",
        props: { strategy: TradeStrategy.FLEX }
      }
      // {
      //   text: this.$t("trade.c2c"),
      //   value: "wyre-trade",
      //   component: "wyre-order-list"
      // }
    ];

    return types;
  }

  get ordersComponent() {
    const item = this.types.find(type => {
      return type.value === this.typeIndex;
    });
    return item?.component ?? "";
  }

  get componentProps() {
    const item = this.types.find(type => {
      return type.value === this.typeIndex;
    });
    return item?.props;
  }

  mounted() {
    setTimeout(() => {
      const i = this.$route.query.i as any;
      const tab = this.types[Number(i)]?.value;
      if (tab) {
        this.typeIndex = tab;
      }
      this.loading = false;
    }, 200);
  }
}
export default Orders;
